import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";

/* eslint-disable max-len */
import BaseFoundation from '../base/foundation';
import { formatDateValues } from './_utils/formatter';
import { getDefaultFormatTokenByType } from './_utils/getDefaultFormatToken';
const KEY_CODE_ENTER = 'Enter';
const KEY_CODE_TAB = 'Tab';
export default class InputFoundation extends BaseFoundation {
  constructor(adapter) {
    super(_Object$assign({}, adapter));
  } // eslint-disable-next-line @typescript-eslint/no-empty-function


  init() {} // eslint-disable-next-line @typescript-eslint/no-empty-function


  destroy() {}

  handleClick(e) {
    this._adapter.notifyClick(e);
  }

  handleChange(value, e) {
    this._adapter.notifyChange(value, e);
  }

  handleInputComplete(e) {
    /**
     * onKeyPress, e.key Code gets a value of 0 instead of 13
     * Here key is used to judge the button
     */
    if (e.key === KEY_CODE_ENTER) {
      this._adapter.notifyEnter(e.target.value);
    }
  }

  handleInputClear(e) {
    this._adapter.notifyClear(e);
  }

  handleRangeInputClear(e) {
    this._adapter.notifyRangeInputClear(e);
  }

  handleRangeInputEnterPress(e, rangeInputValue) {
    if (e.key === KEY_CODE_ENTER) {
      this._adapter.notifyEnter(rangeInputValue);
    }
  }

  handleRangeInputEndKeyPress(e) {
    if (e.key === KEY_CODE_TAB) {
      this._adapter.notifyTabPress(e);
    }
  }

  handleRangeInputFocus(e, rangeType) {
    this._adapter.notifyRangeInputFocus(e, rangeType);
  }

  formatShowText(value) {
    const {
      type,
      dateFnsLocale,
      format,
      rangeSeparator
    } = this._adapter.getProps();

    const formatToken = format || getDefaultFormatTokenByType(type);
    let text = '';

    switch (type) {
      case 'date':
        text = formatDateValues(value, formatToken, undefined, dateFnsLocale);
        break;

      case 'dateRange':
        text = formatDateValues(value, formatToken, {
          groupSize: 2,
          groupInnerSeparator: rangeSeparator
        }, dateFnsLocale);
        break;

      case 'dateTime':
        text = formatDateValues(value, formatToken, undefined, dateFnsLocale);
        break;

      case 'dateTimeRange':
        text = formatDateValues(value, formatToken, {
          groupSize: 2,
          groupInnerSeparator: rangeSeparator
        }, dateFnsLocale);
        break;

      case 'month':
        text = formatDateValues(value, formatToken, undefined, dateFnsLocale);
        break;

      default:
        break;
    }

    return text;
  }

}